import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    formSubtitle: {
        fontFamily: "Source Sans 3",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    helperText: {
        fontFamily: "Source Sans 3",
        fontSize: "12px",
        color: theme.palette.secondary.dark,
    },
    checkboxList: {
        display: "grid !important",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: theme.spacing(2),
    },
    checkboxListLabel: {
        textAlign: "left",
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            "&.Mui-checked": {
                color: theme.palette.info.light,
            },
        },
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    listContainer: {
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
    },
    listItem: {
        display: "flex",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
    },
    keySuccessFactorlistItem: {
        display: "flex",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
        },
    },
    listTextTitle: {
        width: 0,
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
            textTransform: "capitalize",
        },
    },
}));
